export default {
    'App is listening': 'PIWA-000',
    'Request received': 'PIWA-001',
    'The server refused the connection': 'PIWA-011',
    'Retry time exhausted': 'PIWA-012',
    'Retry attempts exhausted': 'PIWA-013',
    'connect-redis reported a client error': 'PIWA-014',
    'Retrieving receive country profile': 'PIWA-201',
    'Retrieved receive country profile': 'PIWA-202',
    'Retrieving CyberSource init data': 'PIWA-203',
    'Retrieved CyberSource init data': 'PIWA-204',
    'Retrieving CyberSource init data failed': 'PIWA-205',
    'Microform createToken failed': 'PIWA-206',
    'Authorization enrollment started': 'PIWA-207',
    'Authorization enrollment succeed': 'PIWA-208',
    'Authorization enrollment failed': 'PIWA-209',
    'Authorization verification started': 'PIWA-210',
    'Authorization verification succeed': 'PIWA-211',
    'Authorization verification failed': 'PIWA-212',
    'CyberSource authorization process failed': 'PIWA-214',
    'Error in Cardinal payments validation process': 'PIWA-215',
    'CyberSource card saved authorization process failed': 'PIWA-216',
    'Retrieving saved cards details': 'PIWA-220',
    'Retrieved saved card details': 'PIWA-221',
    'Error retrieving cards props': 'PIWA-222',
    'Failed to remove credit card': 'PIWA-223',
    'Credit card authorization response succeed': 'PIWA-224',
    'Retrieving Optile init data': 'PIWA-230',
    'Retrieving Optile init data failed': 'PIWA-231',
    'Retrieving Optile bank payment data': 'PIWA-232',
    'Retrieving Optile bank payment data failed': 'PIWA-233',
    'Retrieved Optile init data': 'PIWA-234',
    'Retrieving window.Cardinal data failed': 'PIWA-241',
    'Error retrieving saved cards details': 'PIWA-242',
    'Error removing saved card': 'PIWA-243',
    'Retrieving CyberSource init data from client': 'PIWA-244',
    'Retrieving CyberSource init data from client failed': 'PIWA-245',
    'Retrieving Cybersource card details': 'PIWA-246',
    'Retrieved Cybersource card details': 'PIWA-247',
    'Error retrieving Cybersource card details': 'PIWA-248',
    'Error retrieving Cybersource card details props': 'PIWA-249',
    'Retrieving TrueLayer payment status': 'PIWA-250',
    'Retrieved TrueLayer payment status': 'PIWA-251',
    'Error retrieving TrueLayer payment status': 'PIWA-252',
    'Retrieving TrueLayer providers': 'PIWA-260',
    'Retrieved TrueLayer providers': 'PIWA-261',
    'Error retrieving TrueLayer providers': 'PIWA-262',
    'TrueLayer session initialisation started': 'PIWA-263',
    'Truelayer session initialisation succeed': 'PIWA-264',
    'Truelayer session initialisation failed': 'PIWA-265',
    'Internal route redirect': 'PIWA-300',
    'Invalid CSRF token': 'PIWA-403',
    'Not found': 'PIWA-404',
    'Asset handler error': 'PIWA-511',
    'HTTP Error occured': 'PIWA-513',
    'Redis client retrying': 'PIWA-601',
    'Node version': 'PIWA-999',
    'BIN request started': 'PLC-515',
    'BIN request succeeded': 'PLC-516',
    'BIN request failed': 'PLC-517',
    'Authorization verification request': 'PIWA-016',
    'Error retrieving Manual bank transfer confirmation': 'PIWA-270',
    'Error retrieving Manual bank transfer data': 'PIWA-271',
    'TME request started': 'PIWA-272',
    'TME request succeeded': 'PIWA-273',
    'TME request failed': 'PIWA-274',
    'Retrieving Adyen init data': 'PIWA-280',
    'Retrieved Adyen init data': 'PIWA-281',
    'Error retrieving Adyen init data': 'PIWA-282',
    'Retrieving Adyen status': 'PIWA-285',
    'Retrieved Adyen status': 'PIWA-286',
    'Error retrieving Adyen status': 'PIWA-287',
    'Retrieving Tabapay card details': 'PIWA-290',
    'Retrieved Tabapay card details': 'PIWA-291',
    'Error retrieving Tabapay card details': 'PIWA-292',
    'Error retrieving Tabapay card details props': 'PIWA-293',
    'Tabapay init transaction started': 'PIWA-294',
    'Tabapay init transaction succeed': 'PIWA-295',
    'Tabapay init transaction failed': 'PIWA-296',
    'Retrieving Tabapay status': 'PIWA-297',
    'Retrieved Tabapay status': 'PIWA-298',
    'Error retrieving Tabapay status': 'PIWA-299',
    'Retrieving Zepz Payin init data': 'PIWA-301',
    'Retrieved Zepz Payin init data': 'PIWA-302',
    'Error retrieving Zepz Payin init data': 'PIWA-303',
    'Retrieving Zepz Payin verification status': 'PIWA-305',
    'Retrieved Zepz Payin verification status': 'PIWA-306',
    'Error retrieving Zepz Payin verification status': 'PIWA-307',
    'Retrieving Zepz Payin cards': 'PIWA-308',
    'Retrieved Zepz Payin cards': 'PIWA-309',
    'Error retrieving Zepz Payin cards': 'PIWA-310',
    'Auth payment requested': 'PIWA-311',
    'Auth payment successfully received': 'PIWA-312',
    'Error retrieving Auth payment': 'PIWA-313',
    'Delete Zepz Payin card requested': 'PIWA-314',
    'Zepz Payin card successfully deleted': 'PIWA-315',
    'Failed to delete Zepz Payin card': 'PIWA-316',
    'Zepz Payin - user redirected': 'PIWA-317'
};
